import { render, staticRenderFns } from "./VulnList.vue?vue&type=template&id=68bbbbdb&scoped=true&"
import script from "./VulnList.vue?vue&type=script&lang=ts&"
export * from "./VulnList.vue?vue&type=script&lang=ts&"
import style0 from "./VulnList.vue?vue&type=style&index=0&id=68bbbbdb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bbbbdb",
  null
  
)

export default component.exports